import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import VehicleInformation from './MessageDetails/VehicleInformation.vue';
import TerminalInformation from './MessageDetails/TerminalInformation.vue';
import DriverInformation from './MessageDetails/DriverInformation.vue';
import VehicleWorking from './MessageDetails/VehicleWorking.vue';
import DriverSwiping from './MessageDetails/DriverSwiping.vue';
import RunningData from './MessageDetails/RunningData.vue';
import { domainName } from "../../../utility/index"
import roadBook from "../../../components/roadBook.vue"
import TrailBook from "../../../components/TrailBook.vue"

export default {
  name: 'VehicleStatus',
  components: { tree, iTable, IPagination, VehicleInformation, TerminalInformation, DriverInformation, VehicleWorking, DriverSwiping, RunningData, roadBook, TrailBook },
  data() {
    return {
      isCollapse: false,
      stateArrow: true,
      isSearch: true,
      formInline: {
        selectCarType: '',
        selectCarValue: '',
        typeId: '',
        terminalId: '',
        driverName: '',
        offlineTime: '0',
        linkState: '',
        problem: '',
        onoffState: ''
      },
      optionsInput: [{
        value: '0',
        label: this.$t('common.search.whole')
      }, {
        value: '1',
        label: this.$t('common.carId')
      }, {
        value: '2',
        label: this.$t('common.plateNum')
      }, {
        value: '3',
        label: this.$t('common.customNum')
      },
      {
        value: '4',
        label: this.$t('common.manufactureNum')
      }],
      offlineList: [
        { id: '0', name: this.$t('common.search.whole') },
        { id: '1', name: this.$t('VehicleManagement.oneTwo') },
        { id: '2', name: this.$t('VehicleManagement.oneThree') },
        { id: '3', name: this.$t('VehicleManagement.threeSeven') },
        { id: '4', name: this.$t('VehicleManagement.sevenTen') },
        { id: '5', name: this.$t('VehicleManagement.ten') },
      ],
      StateList: [
        { id: '', name: this.$t('common.search.whole') },
        { id: '1', name: this.$t('common.onLine') },
        { id: '0', name: this.$t('common.offLine') },
      ],
      problemList: [
        { id: '', name: this.$t('common.search.whole') },
        { id: '0', name: this.$t('common.normal') },
        { id: '1', name: this.$t('VehicleManagement.fault') },
      ],
      alarmList: [
        { id: '', name: this.$t('common.search.whole') },
        { id: '0', name: this.$t('VehicleManagement.off') },
        { id: '1', name: this.$t('VehicleManagement.on') },
      ],
      height: '550',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: true,
        serialNumber: true,
      },
      columns: [
        {
          prop: "carId",
          label: this.$t('common.carId'),
          align: "center",
          width: '80'
        },
        {
          prop: "manufactureNum",
          label: this.$t('common.manufactureNum'),
          align: "center",
          width: "150px"
        },
        {
          prop: "customNum",
          label: this.$t('common.customNum'),
          align: "center",
          width: "120px"
        },
        {
          prop: "plateNum",
          label: this.$t('common.plateNum'),
          align: "center",
          width: "120px"
        },
        {
          prop: "terminalId",
          label: this.$t('common.terminalId'),
          align: "center",
          width: '140'
        },
        {
          prop: "driverNum",
          label: this.$t('common.driverNum'),
          align: "center",
          width: '100'
        },

        {
          prop: "name",
          label: this.$t('common.driverName'),
          align: "center",
          width: '100'
        },
        {
          prop: "orgName",
          label: this.$t('common.orgName'),
          align: "center",
          width: '100'
        },
        {
          prop: "messageTime",
          label: this.$t('common.messageTime'),
          align: "center",
          width: '160'
        },
        {
          prop: "power",
          label: this.$t('VehicleManagement.voltage'),
          align: "center",

        },
        {
          prop: "speed",
          label: this.$t('VehicleManagement.speed'),
          align: "center",

        },
        {
          prop: "carryWeight",
          label: this.$t('VehicleManagement.carryWeight'),
          align: "center",

        },
        {
          prop: "workTime",
          label: this.$t('VehicleManagement.workHour'),
          align: "center",
          width: '110'

        },
        {
          prop: "address",
          label: this.$t('VehicleManagement.address'),
          align: "center",
          width: '160'
        },
        {
          prop: 'spotCheckType',
          label: this.$t('VehicleManagement.todayCheck'),
          align: 'center',
          render: (h, params) => {
            return h('el-tag', {
              props: { type: params.row.spotCheckType === null ? '' : params.row.spotCheckType === 0 ? 'success' : 'info' }
            }, params.row.spotCheckType === null ? '' : params.row.spotCheckType === 0 ? this.$t('GovernmentRegulation.checked') : this.$t('GovernmentRegulation.noCheck'))
          }
        },
        {
          prop: "remarks",
          label: this.$t('common.remarks'),
          align: "center",
          width: '110'
        },
        {
          prop: 'linkState',
          label: this.$t('VehicleManagement.deviceStatus'),
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('el-tag', {
              props: { type: params.row.linkState === null ? '' : params.row.linkState === 0 ? 'info' : 'success' }
            }, params.row.linkState === null ? '' : params.row.linkState === 0 ? this.$t('common.offLine') : this.$t('common.onLine'))
          }
        },
        {
          prop: 'onoffState',
          label: this.$t('VehicleManagement.workCondition'),
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('el-tag', {
              props: { type: params.row.onoffState === '' ? '' : params.row.onoffState === 1 ? 'success' : 'info' }
            }, params.row.onoffState === '' ? '' : params.row.onoffState === 1 ? this.$t('VehicleManagement.on') : this.$t('VehicleManagement.off'))
          }
        },
        {
          prop: 'problem',
          label: this.$t('VehicleManagement.faultConditions'),
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('el-tag', {
              props: { type: params.row.problem === '' ? '' : params.row.problem === 0 ? 'success' : 'info' }
            }, params.row.problem === '' ? '' : params.row.problem === 0 ? this.$t('common.normal') : this.$t('VehicleManagement.fault'))
          }
        },
      ],
      dialogFormVisible: false,
      activeName: 'first',
      operates: {
        width: 100,
        fixed: "right",
        list: [
          {
            id: '1',
            show: true,
            icon: 'iconfont iconicon-chakanxq',
            plain: true,
            disabled: false,
            isBtn: "VEHICLESTATUS_DETAIL",
            method: (index, row) => {
              this.dialogFormVisible = true
              this.queryDetails(index, row)
            }
          }
        ],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      terminalId: '',
      carId: '',
      driverNum: '',
      dialogVisible: false,
      dialogVisibleNone: false,
      selected: [],
      carData: '',

      dialogVisibleTrail: false,
      dialogTrailVisible: false,
      terminalData: '',

      form: {
        spotCheckState: ''
      },
      rules: {},
      formLabelWidth: '112px',
      dialogCheckFormVisible: false


    }
  },
  created() {
    this.getTerminalType()
  },

  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
    },
    changeArrow() {
      this.stateArrow = !this.stateArrow
    },
    queryDetails(index, row) {
      this.terminalId = row.terminalId
      this.carId = row.carId
      this.driverNum = row.driverNum
      this.$nextTick(() => {
        this.activeName = 'first'
        this.$refs.carInformation.getSelectOneCar()
      })
    },
    initQuery(item) {
      this.id = item.id
      this.name = item.name
      if (this.$route.params.carId) {
        this.formInline.selectCarValue = this.$route.params.carId
      }
      if (this.$route.params.problemCountId) {
        this.formInline.problem = String(this.$route.params.problemCountId)
      }
      if (this.$route.params.alarmCountId) {
        this.formInline.alarm = String(this.$route.params.alarmCountId)
      }
      this.getRealTimeStatus()

    },
    nodeClick(val) {
      this.id = val.label
      this.name = val.value
      this.getRealTimeStatus()
    },
    getRealTimeStatus() {
      let param = {
        orgId: this.id,
        selectCarType: this.formInline.selectCarType,
        selectCarValue: this.formInline.selectCarValue,
        typeId: this.formInline.typeId,
        terminalId: this.formInline.terminalId,
        driverName: this.formInline.driverName,
        offlineTime: this.formInline.offlineTime,
        linkState: this.formInline.linkState,
        problem: this.formInline.problem,
        onoffState: this.formInline.onoffState,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$store.dispatch('VehicleStatus/GET_REALTIMESTATUS', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      }).catch(err => { })
    },
    onSearch() {
      this.currentPage = 1
      this.getRealTimeStatus()
    },
    onClear() {
      this.formInline = {
        selectCarType: '',
        selectCarValue: '',
        typeId: '',
        terminalId: '',
        driverName: '',
        offlineTime: '0',
        linkState: '',
        problem: '',
        onoffState: ''
      }
      this.getRealTimeStatus()
    },
    getTerminalType() {
      this.$store.dispatch('TerminalCommand/GET_TERMINALTYPE', {}).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.terminalList = res.data.data
          }
        }
      }).catch(err => { })
    },
    carCheck() {
      this.dialogCheckFormVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            carId: this.selected[0].carId,
            spotCheckState: this.form.spotCheckState,
          }
          this.$store.dispatch('VehicleStatus/GET_CARSPOTCHECK', param).then(res => {
            if (res.data.code == 200) {
              this.$message.success(this.$t('common.btn.addSuccess'))
              this.dialogCheckFormVisible = false;
              this.getRealTimeStatus();
              this.closeDia();
            } else {
              this.$message.error(res.data.msg)
            }

          }).catch(err => { })


        } else {
          return false;
        }
      });
    },
    cancle(formName) {
      this.dialogCheckFormVisible = false;
      this.form = {
        spotCheckState: '',
      }
    },
    closeDia() {
      this.form = {
        spotCheckState: '',
      }
      this.dialogCheckFormVisible = false;
    },
    carLocation() {
      this.dialogVisible = true
      this.dialogVisibleNone = true
      this.$nextTick(() => {
        this.$refs.roadBook.getData()
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisibleNone = false
    },

    carTrail() {
      this.dialogVisibleTrail = true
      this.dialogTrailVisible = true
      this.$nextTick(() => {
        this.$refs.TrailBook.getRealTime()
      })
    },
    handleTrailClose() {
      this.dialogVisibleTrail = false
      this.dialogTrailVisible = false
    },

    downCar() {
      if (domainName) {
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}/v1/getExportExcel/exportCarRealTimeStatus?orgId=${this.id}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&typeId=${this.formInline.typeId}&terminalId=${this.formInline.terminalId}&driverName=${this.formInline.driverName}&offlineTime=${this.formInline.offlineTime}&linkState=${this.formInline.linkState}&problem=${this.formInline.problem}&alarm=${this.formInline.onoffState}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}/v1/getExportExcel/exportCarRealTimeStatus?orgId=${this.id}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&typeId=${this.formInline.typeId}&terminalId=${this.formInline.terminalId}&driverName=${this.formInline.driverName}&offlineTime=${this.formInline.offlineTime}&linkState=${this.formInline.linkState}&problem=${this.formInline.problem}&alarm=${this.formInline.onoffState}`
          location.href = url
        }
      }
    },
    handleSelectionChange(val) {
      this.selected = val
      this.carData = this.selected[0].carId
      this.terminalData = this.selected[0].terminalId
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getRealTimeStatus();
    },
    handleClick(event) {
      this.activeName = event.name
      if (this.activeName == 'first') {
        this.$nextTick(() => {
          this.$refs.carInformation.getSelectOneCar()
        })
      } else if (this.activeName == 'second') {
        this.$nextTick(() => {
          this.$refs.terminalInformation.getSelectOneTerminal()
        })
      } else if (this.activeName == 'third') {
        this.$nextTick(() => {
          this.$refs.driverInformation.getSelectOneDriver()
        })
      } else if (this.activeName == 'fourth') {
        this.$nextTick(() => {
          this.$refs.vehicleWorking.getCarRealTime()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.runningData.getRunningData()
        })

      }
    },
    onResize: function (x, y, width, height) {
      let box = document.getElementById("leftBox");
      box.style.width = width + "px";
    },
  }
}